module.exports = __webpack_public_path__ + "img/BatInduO.e1f6a6fa.png";